import angular from 'angular';
import { map, sortBy } from 'lodash';

import analytics from 'common/analytics';

import './calendar-dashboard.style.sass';
import template from './calendar-dashboard.tpl.pug';

class CalendarDashboardController {
    /* @ngInject */
    constructor(numberUtil) {
        this.numberUtil = numberUtil;

        this.selectExpenseType();
    }

    $onChanges(changeObject) {
        if (this.expenseSelected) {
            if (changeObject.expense || changeObject.expenseCategoryGroups) {
                this.selectExpenseType();
            }
        } else if (changeObject.income || changeObject.incomeCategoryGroups) {
            this.selectIncomeType();
        }
    }

    isValueValid(value) {
        return this.numberUtil.isNumeric(value);
    }

    selectIncome() {
        analytics.trackDashboardSelectIncome();

        this.selectIncomeType();
    }

    selectExpense() {
        analytics.trackDashboardSelectExpense();

        this.selectExpenseType();
    }

    selectIncomeType() {
        this.selectType(false, this.income, this.incomeCategoryGroups || [], 'surplus', 'deficit');
    }

    selectExpenseType() {
        this.selectType(true, this.expense, this.expenseCategoryGroups || [], 'exceeded by', 'saved');
    }

    selectType(expenseSelected, total, groups, exceeded, saved) {
        this.expenseSelected = expenseSelected;
        this.groups = sortBy(map(groups, (group) => {
            return angular.merge(group, {
                eventGroups: group.eventGroups.map((eventGroup) => {
                    return angular.merge(eventGroup, {
                        note: eventGroup.note
                            ? eventGroup.note
                            : `without label`
                    });
                })
            });
        }), (group) => -group.totalCurrentValue);
        this.colors = groups.map((group) => {
            return {
                label: `${group.name}: ${group.totalCurrentValue}`,
                color: group.color,
                percent: Math.abs(group.totalCurrentValue) / total * 100
            };
        });

        this.exceeded = exceeded;
        this.saved = saved;
    }
}

export default {
    selector: 'dbACalendarDashboard',
    template: template(),
    controller: CalendarDashboardController,
    bindings: {
        loading: '<',
        monthName: '<',
        income: '<',
        incomeCategoryGroups: '<',
        expense: '<',
        expenseCategoryGroups: '<'
    }
};



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/calendar/component/calendar-dashboard/calendar-dashboard.cmpt.js